import { Skeleton } from "@storybook";
import { Card } from "components";
import { Fragment } from "react/jsx-runtime";

export const SignInMethodSkelton = () => {
  return (
    <Card className="flex direction-col gap-16 w-480 sm-border-0">
      <Fragment>
        <Skeleton height={48} width={200} borderRadius={4} />
        <Skeleton height={24} width={244} borderRadius={4} />
        <Skeleton height={16} width={385} borderRadius={4} />

        <Skeleton height={48} width={430} borderRadius={4} />
        <Skeleton height={48} width={430} borderRadius={4} />

        <Skeleton height={48} width={430} borderRadius={4} />
      </Fragment>
    </Card>
  );
};
